export default async function ({ store, redirect }) {
  if (!store.getters["user/IS_BAND"]) return redirect("/")
  else {
    if (store.getters["user/IS_AGENCY"])
      return redirect("/band/profile/select/")
    else return redirect("/band/profile/" + store.state.user.band_set[0].slug)
  }
}
